import { render, staticRenderFns } from "./OrderSessionPrintout.vue?vue&type=template&id=52052fa6&scoped=true&"
import script from "./OrderSessionPrintout.vue?vue&type=script&lang=js&"
export * from "./OrderSessionPrintout.vue?vue&type=script&lang=js&"
import style0 from "./OrderSessionPrintout.vue?vue&type=style&index=0&id=52052fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52052fa6",
  null
  
)

export default component.exports